<template>
  <Layout>
    <div slot="content">
      <div class="row">
        <div class="col-xl-6">
          <TableView hide-pagenation @action="action" :title="$t('권한')" :columns="cols" min-width="auto" minHeight="450px"
            :list="roleList" :icon-actions="auths.includes('MAIN_ROLE_EDIT') ? {'bi-pencil-fill': '수정', 'bi-trash-fill': '권한삭제'} : {'bi-eye-fill': '조회'}">
            <button v-if="auths.includes('MAIN_ROLE_EDIT')" class="btn btn-primary" @click="sel = {}; list = []; action({ action: '추가', item: {} })"
              v-text="$t('권한 추가')" />
          </TableView>
        </div>
        <div class="col-xl-6">
          <TableView @action="action" :actions="['삭제']" :title="sel.roleNm || ''" :list="list" :columns="roleCols" min-width="auto" minHeight="450px">
            <div class="d-flex align-items-center position-relative">
              <b-icon icon="search" />
              <input maxlength="100" @keydown.enter="prevent" @change="searchKeyword = $event.target.value;"
                class="form-control form-control-solid w-200px ps-11" :placeholder="$t('사용자명, 아이디, 이메일')" :title="$t('사용자명, 아이디, 이메일')">
              <button :disabled="!sel.roleId" class="ms-3 btn btn-primary" @click="subAction({ action: '배정' })"
                v-text="$t('멤버 배정')" />
            </div>
          </TableView>
        </div>
      </div>
    </div>
    
    <ModalForm id="edit" :label-cols="3" ok-title="저장" @action="action" :title="$t(auths.includes('MAIN_ROLE_EDIT') ? (sel.roleId ? '권한 수정' : '권한 추가') : '권한 조회')"
      :data="sel" :spec="cols" :hide-footer="$t(auths.includes('MAIN_ROLE_EDIT') ? false : true)">
      <template slot="bottom">
        <!-- <div v-for="(list, title, i) of roles" :key="'role' + i"
          class="role-roles form-switch form-check-sm form-check-custom form-check-solid">
          <h5><label v-text="title" :for="`role${i}`" /><input
              @change="({ target: { checked } }) => list.forEach(r => r.roleYn = checked ? 'Y' : 'N')"
              v-model="roleChecks[i]" :id="`role${i}`" type="checkbox" class="form-check-input" /></h5>
          <div v-for="(sub, j) of list" :key="j"><label v-text="sub.actionNm" :for="`role${i}_${j}`" /><input
              :checked="list[j].roleYn == 'Y'" @change="({ target: { checked } }) => list[j].roleYn = checked ? 'Y' : 'N'"
              :id="`role${i}_${j}`" type="checkbox" class="form-check-input" /></div>
        </div> -->
        <div v-for="(list, title, i) of roles" :key="'role' + i"
          class="role-roles form-switch form-check-sm form-check-custom form-check-solid">
          <h5><label v-text="title" :for="`role${i}`" /><input
              @change="({ target: { checked } }) => list.forEach(c => c.roleActionList.forEach(r => r.roleYn = checked ? 'Y' : 'N'))"
              v-model="roleChecks[i]" :id="`role${i}`" type="checkbox" class="form-check-input" /></h5>
            <div v-for="(cat, k) of list" :key="k"><label v-if="cat.dispYn=='Y'" style="margin: 0 0 5px -15px;color:green" v-text="cat.cateNm" />
              <div v-for="(sub, j) of cat.roleActionList" :key="j"><label v-text="sub.actionNm" :for="`role${i}_${j}_${k}`" /><input
                :checked="list[k].roleActionList[j].roleYn == 'Y'" @change="({ target: { checked } }) => list[k].roleActionList[j].roleYn = checked ? 'Y' : 'N'"
                :id="`role${i}_${j}_${k}`" type="checkbox" class="form-check-input" /></div>
            </div>
        </div>
      </template>
    </ModalForm>
    <b-modal id="배정" :title="$t('멤버 배정')" dialog-class="min-w-1024px" body-class="p-5 pt-3" hide-footer>
      <div class="d-flex flex-column">
          <div class="d-flex justify-content-between mb-2">
            <div class="d-flex justify-content-end">
              <div class="d-flex align-items-center position-relative">
                <b-icon icon="search" />
                <input type="text" v-model="partiParams.searchKeyword" class="form-control form-control-solid form-control ps-11 pe-12 w-500px border-def" maxlength="100"
                  :placeholder="$t('조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명')"
                  :title="$t('조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명')"
                  @keydown="onTyping = true" 
                  @keyup.enter="searchPartiMemberList">
                <a v-if="partiParams.searchKeyword" @click="removeSearchPartiMember"
                  class="icon btn btn-sm btn-icon btn-circle btn-icon-primary btn-active-light-primary position-absolute end-0 me-1">
                  <i class="bi bi-x-circle fs-3"></i>
                </a>
              </div>
              <a class="btn btn-secondary ms-1" :class="{'d-none': !partiSearchMode}" @click="removeSearchPartiMember">
                <i class="bi bi-arrow-left-short"></i>{{ $t('조직도') }}
              </a>
            </div>
            <b-button v-if="!unmaskKey && (allPartiMemberList.length || partiMemberList.length)" class="btn-sm" @click="reqUnmask()" variant="warning">
              {{ $t('마스킹 해제') }}
            </b-button>
          </div>
          <div style="height: 64vh;" class="row">
            <div class="h-100 d-flex" :class="{'d-none': partiSearchMode}">
              <div class="h-100" style="width: 38%;">
                <TreeView2 ref="partiSelTree" size="lg" :treeData="partiSelTree" @clicked="choicePartiGrp" height="100%"
                  :filterHolder="$t('조직명, 그룹명')" showOuterBorder></TreeView2>
              </div>
              <div class="h-100 ms-4" style="width: 62%;">
                <div class="ps-2" style="height: 30px;">
                  <span v-text="$t('$ 명', [partiSearchMode ? allPartiMemberList.length : partiMemberList.length])"></span>
                </div>
                <div style="height: calc(100% - 30px)">
                  <TableView ref="partiMemberTable" class="table-break-all" :list="partiMemberList" :actions="['선택']" actionSize="xs" hideActionLabel 
                    min-width="auto" height="100%" minHeight="150px" hidePagination showOuterBorder @action="assignPartiMember"
                    :columns="[
                      { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
                      { key: 'email', label: '이메일', style: { textAlign: 'center' } },
                      { key: 'grpNm', label: '그룹', style: { textAlign: 'center' } },
                      { key: 'roleNms', label: '권한', style: { textAlign: 'center' } },
                    ]">
                  </TableView>
                </div>
              </div>
            </div>
            <div class="h-100" style="width: 100%;" :class="{'d-none': !partiSearchMode}">
              <div class="ps-2" style="height: 30px;">
                <span v-text="$t('$ 명', [partiSearchMode ? allPartiMemberList.length : partiMemberList.length])"></span>
              </div>
              <div style="height: calc(100% - 30px)">
                <TableView ref="allPartiMemberTable" class="table-break-all" :list="allPartiMemberList" :actions="['선택']" actionSize="xs" hideActionLabel 
                  min-width="auto" height="100%" minHeight="150px" hidePagination showOuterBorder @action="assignPartiMember"
                  :columns="[
                    { key: 'custAbbr', label: 'Cust Abbr.', style: { textAlign: 'center' } },
                    { key: 'custName', label: '조직명', style: { textAlign: 'center' } },
                    { key: 'custFullName', label: '조직영문명', style: { textAlign: 'center' } },
                    { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
                    { key: 'email', label: '이메일', style: { textAlign: 'center' } },
                    { key: 'grpNm', label: '그룹', style: { textAlign: 'center' } },
                    { key: 'roleNms', label: '권한', style: { textAlign: 'center' } },
                  ]">
                </TableView>
              </div>
            </div>
          </div>
        </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import TreeView2 from "@/components/TreeView2.vue";
import ModalForm from "@/components/ModalForm.vue";
const required = true;

export default {
  components: { Layout, TableView, TreeView2, ModalForm },
  computed: {
    auths() { return this.$store.state.user.auths || [] },
  },
  data: () => ({
    roles: {}, roleChecks: [], sel: {}, selSub: {}, searchKeyword: '', list: [], roleList: [],
    partiSelTree: '', unmaskKey: '', onTyping: false, partiSearchMode: false,
    partiMemberList: [], allPartiMemberList: [], partiParams: { selType: '', selKey: '', searchKeyword: '' }, 
    cols: [
      { key: 'roleNm', label: '권한명', required, form: 1, style: { textAlign: 'center' } },
      { key: 'description', label: '설명', type: 'textarea', form: 2 },
    ],
    roleCols: [
      { label: '구분', renderer: (r, s) => s.$t(r.userId ? '사용자' : '그룹'), style: { textAlign: 'center' } },
      { label: '그룹/멤버', renderer: (r) => r.userId ? `${r.userNm} (${r.userIdText}, ${r.email}${r.grpNm ? ', ' + r.grpNm : ''})` : r.grpNm },
    ],
  }),
  async created() { this.getRoleList() },
  mounted() {
    this.$reduceScreen();
  },
  watch: { orgChartKeyword(q) { this.$treeKeywordChange(q, '배정') } },
  methods: {
    async getList() {   // 권한에 배정된 사용자 목록 조회
      this.list = [];
      this.list = ((await this.$api('main/role/selectRoleGrpList', { roleId: this.sel.roleId, searchKeyword: this.searchKeyword || null })).list || []).concat(
        (await this.$api('main/role/selectRoleMemberList', { roleId: this.sel.roleId, searchKeyword: this.searchKeyword || null })).list || [])
    },
    async getRoleList() {   // 권한 목록 조회
      this.roleList = (await this.$api('main/role/selectRoleList', {})).list || [];
      this.$nextTick(() => { this.list = []; });
    },
    async prevent(event) {
      event.preventDefault();
      this.searchKeyword = event.target.value;
      this.list = [];
      this.list = ((await this.$api('main/role/selectRoleGrpList', { roleId: this.sel.roleId, searchKeyword: this.searchKeyword || null })).list || []).concat(
        (await this.$api('main/role/selectRoleMemberList', { roleId: this.sel.roleId, searchKeyword: this.searchKeyword || null })).list || [])
    },
    async subAction({ action, item, form }) {      
      if (item) this.selSub = item;
      else if (!form && ['배정'].includes(action)) {
        this.openPartiSelTree();
        return;
      }
    },
    async action({ action, item, form }) {
      if (action == 'view' && !item.roleNm) return;
      else if (item && item.roleNm) this.sel = item;
      if (['view'].includes(action)) return this.getList();
      else if (!form && ['수정', '추가', '조회'].includes(action)) {
        this.roles = {};
        this.roleChecks.length = 0;
        const { data: { roleActionList, topMenuList, actionCateList } } = await this.$api('main/role/selectRoleActionList', { roleId: this.sel.roleId });
        actionCateList.forEach(c => c.roleActionList = roleActionList.filter(r => r.cateId == c.cateId));
        topMenuList.forEach(m => this.roles[`${m.menuNm}`] = actionCateList.filter(r => r.menuId == m.menuId));
        // topMenuList.forEach(m => this.roles[`${m.menuNm} ${this.$t('관리')}`] = roleActionList.filter(r => r.menuId == m.menuId));
        this.$forceUpdate();
        return this.$bvModal.show('edit');
      }
      else if (['권한삭제'].includes(action) && !(await this.$alert(this.$t('[$] 권한을 $ 하시겠습니까?', [item.roleNm,this.$t('삭제')]), { confirm: true }))) return;
      else if (['삭제'].includes(action)) {
        if (!item.userId) action = '그룹삭제';
        form = { roleId: this.sel.roleId, userId: item.userId, grpId: item.grpId };
        if (!(await this.$alert(this.$t('[$] 배정 삭제 하시겠습니까?', [item.userNm || item.grpNm]), { confirm: true }))) return;
      }
      else if (form) {
        action = this.sel.roleId ? '수정' : '추가';
        let _roleActionList = [];
        Object.values(this.roles).forEach(role => {
          role.forEach(item => {
            if(item.hasOwnProperty('roleActionList')) { _roleActionList.push(...item.roleActionList); }
          });
        });
        const custId = this.$store.state.user.custId, roleId = this.sel.roleId, roleActionList = _roleActionList.map(({ actionId, roleYn }) => ({ custId, roleId, actionId, roleYn }));
        Object.assign(form, { roleId, roleActionList });
      }
      const { success, msg } = await this.$api(`main/role/${({ 삭제: 'deleteRoleMember', 그룹삭제: 'deleteRoleGrp', 권한삭제: 'deleteRole', 추가: 'insertRole', 수정: 'updateRole' })[action]}`, form || { roleId: item.roleId });
      await this.$alert(msg);
      if (success) this[['그룹삭제', '삭제'].includes(action) ? 'getList' : 'getRoleList']();
    },
    async openPartiSelTree() {
      // 매번 초기화
      let custItems = [];
      const custList = (await this.$api('main/role/selectPartiGrpList', {})).list;
      custList.forEach((cust) => {
        let custItem = Object.assign(cust, {icon: 'bi-building-fill', type: 'cust', key: cust.custId, label: cust.custName, children: []});
        custItems.push(custItem);
        for(const grp of cust.grpList) {
          let currItem = grp.pGrpId == 0 ? custItem : cust.grpList.find(d => d.grpId == grp.pGrpId)
          currItem.children.push(Object.assign(grp, {icon: 'bi-people-fill', type: 'grp', key: grp.grpId, label: grp.grpNm, children: []}));
        }
      });

      this.partiSelTree = [...custItems];
      this.partiParams = { selType: '', selKey: '', searchKeyword: '' };
      this.partiSearchMode = false;
      
      // 참여자 목록 초기화
      this.$nextTick(() => {
        this.partiMemberList = [];
        this.allPartiMemberList = [];
        this.$refs.partiSelTree.selectItem(1, 'cust');
      });
      
      this.$bvModal.show('배정');
    },
    async choicePartiGrp({item} = {}) {
      this.onTyping = false;
      this.partiParams.selType = item.type;
      this.partiParams.selKey = item.key;
      this.partiParams.searchKeyword = '';
      this.unmaskKey = '';
      this.selectPartiMemberList(item.type == 'cust' ? {selCustId: item.key} : {selGrpId: item.key});
    },
    async searchPartiMemberList() {
      if(this.partiParams.searchKeyword) {
        this.onTyping = false;
        this.unmaskKey = '';
        this.selectPartiMemberList({searchKeyword: this.partiParams.searchKeyword});
      }
    },
    async removeSearchPartiMember() {
      this.partiParams.searchKeyword = '';
      this.partiSearchMode = false;
      this.unmaskKey = '';
    },
    async reqUnmask() {
      const { success, msg, data } = await this.$api('cmm/unmask', { unmaskActCd: 'GRP_SRC_MEMBER' });
      if (!success) return this.$alert(msg);
      this.unmaskKey = data.unmaskKey;
      if(this.partiSearchMode) {
        this.selectPartiMemberList({searchKeyword: this.partiParams.searchKeyword, unmaskKey: this.unmaskKey});
      } else {
        let params = this.partiParams.selType == 'cust' ? {selCustId: this.partiParams.selKey} : {selGrpId: this.partiParams.selKey};
        params.unmaskKey = this.unmaskKey;
        this.selectPartiMemberList(params);
      }
    },
    async selectPartiMemberList(params) {
      if(!this.onTyping) {
        if(this.partiParams.searchKeyword) { // 검색 모드
          this.allPartiMemberList = [];
          const resultList = (await this.$api('main/role/selectPartiMemberList', params)).list;
          this.allPartiMemberList = [...resultList];
          this.partiSearchMode = true;
        } else {
          this.partiMemberList = [];
          const resultList = (await this.$api('main/role/selectPartiMemberList', params)).list;
          this.partiMemberList = [...resultList];
          this.partiSearchMode = false;
        }
        this.onTyping = false;
      }
    },
    async assignPartiMember({item}) {
      const { roleId } = this.sel;
      let res = await this.$api('main/role/insertRoleMember', { roleId, userId: item.userId });
      this.$bvModal.hide('배정');
      await this.$alert(res.msg);
      if (res.success) this.getList();
    },
  },
}
</script>
